import React from 'react';
import aboutThumb from '../../../assets/images/receipt-pos.jpg';

function ShowCase() {
    return (
        <>
            <section className="appie-about-area mb-50  pt-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div
                                className="appie-about-box wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="row align-items-center">
                                    <div className="col-lg-5">
                                        <div className="about-thumb">
                                            <img
                                                className="rounded"
                                                src={aboutThumb}
                                                alt="OTO POS Receipt"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="appie-about-content">
                                            <span>Integrated POS</span>
                                            <h3 className="title">
                                                Offer the best possible experience to your customers
                                            </h3>
                                            <p>
                                                Take your business to the next level, and improve
                                                profitability and customer satisfaction along the
                                                way.
                                            </p>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h4 className="title">Customizable bills</h4>
                                                    <p>
                                                        OTO offers a customizable bill layout that
                                                        allows businesses to enhance their brand
                                                        image, increase customer recognition
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h4 className="title">
                                                        Customizable Payment Methods
                                                    </h4>
                                                    <p>
                                                        Whether you prefer to accept cash, credit
                                                        cards, mobile payments, or any combination
                                                        thereof, our app has you covered
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h4 className="title">Billing</h4>
                                                    <p>
                                                        Print receipts/Bills that include all
                                                        necessary transaction details, as well as
                                                        any custom messages or promotions
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h4 className="title">Ipad / Mobile Orders</h4>
                                                    <p>
                                                        Our POS app also offers the ability to take
                                                        orders directly from tablets or mobile
                                                        devices
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ShowCase;
